/**
 * Generate a unique supplier code with "SUP" prefix and random suffix
 * Format: SUP + 7 random alphanumeric characters (total 10 characters)
 */
export const generateSupplierCode = (): string => {
  const prefix = 'SUP';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let suffix = '';
  for (let i = 0; i < 7; i++) {
    suffix += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return prefix + suffix;
};

/**
 * Generate a unique customer code with "CUS" prefix and random suffix
 * Format: CUS + 7 random alphanumeric characters (total 10 characters)
 */
export const generateCustomerCode = (): string => {
  const prefix = 'CUS';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let suffix = '';
  for (let i = 0; i < 7; i++) {
    suffix += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return prefix + suffix;
};
